module.exports = __webpack_public_path__ + "img/future_cast.75dafcbe.png";